import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Renderer2,
  HostListener,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";

import { Subscription } from "rxjs";

import { TranslateService } from "@ngx-translate/core";

import { NavigationService } from "app/core/services/navigation.service";
import { LayoutService } from "app/core/services/layout.service";
import { ThemeService } from "app/core/services/theme.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "app/core/services/user.service";
import { MessagingService } from "app/core/services/messaging.service";
import { NotlistService } from "app/modules/admin/notification-list/services/notlist.service";
import { decodedToken } from "app/core/helpers/token.helper";
@Component({
  selector: "app-header-top",
  templateUrl: "./header-top.component.html",
})
export class HeaderTopComponent
  implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  layoutConf: any;
  notificationCall: Subscription;
  menuItems: any;
  menuItemSub: Subscription;
  tgssThemes: any[] = [];
  isInSettingsMenu: boolean = false;
  settingsIndex: any = 0;
  currentLang = "en";
  availableLangs = [
    {
      name: "English",
      code: "en",
    },
    {
      name: "Spanish",
      code: "es",
    },
  ];
  @Input() notificPanel;
  @Output('emitList') public emitList = new EventEmitter<any>()
  userdetails: any;
  constructor(
    private layout: LayoutService,
    private navService: NavigationService,
    public themeService: ThemeService,
    public translate: TranslateService,
    private renderer: Renderer2,
    private router: Router,
    private userService: UserService,
    private messagingService: MessagingService,
    private notificationlistservice: NotlistService,
    private activatedRoute: ActivatedRoute
  ) {
    const token = window.localStorage.getItem("OGJWTTOKEN");
    this.messagingService.requestPermission(token);
    this.messagingService.receiveMessage();
  if (window.localStorage.getItem("OGJWTTOKEN") != null) {
    this.activatedRoute.queryParamMap.subscribe((res:any)=>{
      this.getUnreadmsg()
    })
    this.userdetails = decodedToken();
    }

   
  }
  @HostListener("window:resize", ["$event"])
  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.tgssThemes = this.themeService.tgssThemes;
    this.menuItemSub = this.navService.menuItems$.subscribe((res) => {
      res = res.filter(
        (item) => item.type !== "icon" && item.type !== "separator"
      );
      let limit: any;
      if (
        window.matchMedia(`(max-width: 1251px) and (min-width: 1100px)`).matches
      ) {
        limit = 4;
      } else if (window.matchMedia(`(max-width: 1099px)`).matches) {
        limit = 3;
      } else if (window.matchMedia(`(max-width: 1281px)`).matches) {
        limit = 4;
      } else if (
        window.matchMedia(`(max-width: 1460px) and (min-width: 1282px)`).matches
      ) {
        limit = 5;
      } else if (
        window.matchMedia(`(max-width: 1536px) and (min-width: 1460px)`).matches
      ) {
        limit = 6;
      } else if (window.matchMedia(`(min-width: 1600px)`).matches) {
        limit = 10;
      }
      let mainItems: any[] = res.slice(0, limit);
      if (res.length <= limit) {
        return (this.menuItems = mainItems);
      }
      let subItems: any[] = res.slice(limit, res.length);
      mainItems.push({
        name: "More",
        type: "dropDown",
        tooltip: "More",
        icon: "more_horiz",
        sub: subItems,
      });
      this.menuItems = mainItems;
    });
  }
  public notRandomId: any;
  ngAfterViewInit(): void {
    if (window.localStorage.getItem("OGJWTTOKEN") != null) {
      this.getUnreadmsg();
      this.notificationCount();
    }

    //  let token = JSON.parse(localStorage.getItem('OGJWTTOKEN'))
    //  this.messagingService.sendFCMToken(token)
  }
  ngOnChanges() {}

  route(link) {
    this.router.navigate([`/${link}/category`]);
    // window.localStorage.setItem('settingsIndex', '0');
  }
  ngOnDestroy() {
    this.menuItemSub.unsubscribe();
  }
  setLang() {
    this.translate.use(this.currentLang);
  }
  changeTheme(theme) {
    this.layout.publishLayoutChange({ matTheme: theme.name });
  }
  toggleNotific() {
    this.notificPanel.toggle()
  }
  // bell icon emits the list value
  emitValue(){
    this.getUnreadmsg()
    setTimeout(() => {
    this.emitList.emit(this.notificationList)
    }, 1000);
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === "closed") {
      return this.layout.publishLayoutChange({
        sidebarStyle: "full",
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: "closed",
    });
  }
  getLink(item) {
    // ////console.log(item, "state");
    // //console.log(item.sub[0].state, "13421343434343434343434343434");
    if (item?.name === "Settings") {
      if (item?.sub) {
        return this.isInSettingsMenu == true
          ? item?.sub[this.settingsIndex]?.state
          : item?.sub[0]?.state;
      } else return item?.state;
    } else {
      return item?.state;
    }
  }
  public notificationList: [];
  getUnreadmsg() {
    // //console.log('notificationCall','--------->>>>')
    this.notificationlistservice
      .getAllnotification("")
      .subscribe((res: any) => {
        if (res?.keyword == "success") {
          let data = res?.data;
          let readmsg = data.filter((ele) => ele.msg_read == 0);
          this.notificationList = readmsg;
          this.navService.notificationCount.next(readmsg?.length);
          this.notificationCount();
          this.activatedRoute.queryParams.subscribe((res: any) => {
            //console.log(res?.notId, "in header");
            let randomId = res?.notId;
            //console.log(randomId, "in header");
            if (randomId != undefined) {
              //console.log(this.notificationList, "list");
              let id = this.notificationList.filter(
                (ele: any) => ele?.data?.random_id == randomId
              );
              //console.log(id);
  
              if (id != undefined) {
                this.readNotification(id[0]);
              } else {
                //console.log("already read ");
              }
            }
          });
        } else {
          // this.notificationCall.unsubscribe()
        }
      });
  }

  readNotification(ele: any) {
    let formData = new FormData();
    formData.append("id", JSON.stringify([ele?.notification_id]));
    this.notificationlistservice
      .readNotification(formData)
      .subscribe((res: any) => {
        if (res?.keyword == "success") {
          this.notificationlistservice
            .getAllnotification("")
            .subscribe((res: any) => {
              if (res?.keyword == "success") {
                let data = res?.data;
                let readmsg = data.filter((ele) => ele.msg_read == 0);
                this.navService.notificationCount.next(readmsg?.length);
                this.notificationCount();
                // return readmsg
              }
            });
        }
      });
  }

  public count: number = 0;
  notificationCount() {
    this.navService.getCount().subscribe((res: any) => {
      this.count = res;
    });
  }

  signout() {
    this.messagingService.onLogout().subscribe();
    this.userService.logout();
  }
}
